<app-chart-layout
    [isStatisticScreen]="isStatisticScreen()"
    [isTitleCentred]="isTitleCentred()"
    [subtitle]="computedStatistic().description ?? ''"
    [title]="translateName() ? (computedStatistic().name | transloco) : computedStatistic().name">
    <div class="flex flex-row items-center gap-2">
        <div
            class="relative w-full max-w-full overflow-hidden"
            id="chart">
            <div
                [class.tooltip-styled]="!!tooltipMessage"
                [matTooltip]="tooltipMessage()">
                <app-base-chart
                    [isHeightClassApplied]="false"
                    [isMapExpanded]="isExpanded()"
                    [options]="options()" />
            </div>
        </div>
    </div>
</app-chart-layout>
